import React from "react";
import { Steps } from "../../../../components/Steps";
import SelectDrinkSizeStep from "../SelectDrinkSizeStep";
import SetDrinkSizesStep from "../SetDrinkSizesStep";
import SetExtraIngredients from "../SetExtraIngredients";
import SetAvailabilityStep from "../../SetAvailabilityStep";

import styles from "../../../../../styles/add-category.module.scss";
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/core/Icon";
import SelectSizeStep from "../SelectSizeStep";

const StepNames = {
    NAME_AND_NUM_SIZES: 'NAME_AND_SIZE',
    DEFAULT_SIZES: 'DEFAULT_SIZES',
    SIZES: 'SIZES',
    EXTRA_INGREDIENTS: 'EXTRA_INGREDIENTS',
    AVAILABILITY: 'AVAILABILITY'
}

export class CategoryDrink extends React.Component {

    state = {
        category: {
            type: 'category',
            name: null,
            mode: null,
            single_size: false,
            default_sizes: undefined,
            show: true,
            highlight: false,
            availability: null,
            extra_ingredients: [],
            doughs: [],
            edges: [],
            items: [],
            sizes: [],
            image: null
        },
        steps: 5,
        step: StepNames.NAME_AND_NUM_SIZES,
        currentStep: 1,
        disabled: true
    }

    componentDidMount() {
        const { category } = this.props;
        this.setState({ category });
    }

    onChangeCategory(values) {
        const { category } = this.state;
        this.setState({
            category: { ...category, ...values }
        }, this.validateStep.bind(this));
    }

    validateStep() {
        const { step, category } = this.state;
        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return this.setState({ disabled: !category || !category.name || category.sizes.length == 0 });
            case StepNames.DEFAULT_SIZES:
                return this.setState({ disabled: category.default_sizes === undefined });
            case StepNames.SIZES:
                return this.setState({
                    disabled: category.sizes.reduce((f, size) => (f || (!size.package || !size.unit || !size.amount)), false)
                })
            case StepNames.EXTRA_INGREDIENTS:
                return this.setState({
                    disabled: (
                        category.extra_ingredients.length > 0
                        && !(category.extra_ingredients.reduce((previousExtra, extra) => {
                            return previousExtra && !!extra.name && extra.sizes.reduce((previousExtraSize, extraSize) => {
                                return previousExtraSize && !!extraSize.name && !!extraSize.price && Number(String(extraSize.price)) != NaN
                            }, true)
                        }, true))
                    )
                })
            case StepNames.AVAILABILITY:
                return this.setState({
                    disabled: category.availability === null ? false : (
                        category.availability.daysOfTheWeek > 0
                        && !category.availability.periods.reduce((previousPeriod, period) => {
                            return previousPeriod && (!!period.beginTime && !!period.endTime)
                        }, true)
                    )
                });
        }
    }

    getCorrectSize(category) {
        const { sizes } = category;

        //Adicionar tamanhos novos nos ingrediente extras
        for (const size of sizes) {
            for (const extra of category.extra_ingredients) {
                const extraSizeRefIds = extra.sizes.map((s) => s.ref_id)
                if(!extraSizeRefIds.includes(size.ref_id)) {
                    extra.sizes.push(size)
                }
            }
        }

        //Atualizar os tamanhos dos ingredientes extras já pré-existentes
        for (const size of sizes) {
            for (const extra of category.extra_ingredients) {
                for (const extraSize of extra.sizes) {
                    if(extraSize.ref_id == size.ref_id) {
                        extraSize.name = size.name;
                        extraSize.amount = size.amount;
                        extraSize.unit = size.unit;
                        extraSize.package = size.package;
                    }
                }
            }
        }
        //Remover os que deixaram de existir
        const sizesRefIds = sizes.map((s) => s.ref_id);
        for (const extra of category.extra_ingredients) {
            extra.sizes = extra.sizes.filter((s) => sizesRefIds.includes(s.ref_id));
        }

        return category;
    }

    nextStep() {
        const { step, category } = this.state;

        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return this.setState({
                    step: category.sizes.length == 1 ? StepNames.SIZES : StepNames.DEFAULT_SIZES,
                    currentStep: category.sizes.length == 1 ? 3 : 2,
                    disabled: true,
                    category: {
                        ...category,
                        single_size: category.sizes.length == 1
                    }
                }, this.validateStep.bind(this));
            case StepNames.DEFAULT_SIZES:
                return this.setState({
                    step: category.default_sizes ? StepNames.SIZES : StepNames.AVAILABILITY,
                    currentStep: category.default_sizes ? 3 : 5,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.EXTRA_INGREDIENTS,
                    currentStep: 4,
                    category: this.getCorrectSize(category),
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.EXTRA_INGREDIENTS:
                return this.setState({
                    step: StepNames.AVAILABILITY,
                    currentStep: 5,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return false;
        }
    }

    prevStep() {
        const { step, category } = this.state;
        const { onPrev } = this.props;

        switch (step) {
            case StepNames.NAME_AND_NUM_SIZES:
                return onPrev && onPrev();
            case StepNames.DEFAULT_SIZES:
                return this.setState({
                    step: StepNames.NAME_AND_NUM_SIZES,
                    currentStep: 1,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.SIZES:
                return this.setState({
                    step: category.sizes.length === 1 ? StepNames.NAME_AND_NUM_SIZES : StepNames.DEFAULT_SIZES,
                    currentStep: category.sizes.length === 1 ? 1 : 2,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.EXTRA_INGREDIENTS:
                //Se não tiver tamanhos padrões, voltar para a seleção de tamanhos padrões
                return this.setState({
                    step: category.default_sizes === false ? StepNames.DEFAULT_SIZES : StepNames.SIZES,
                    currentStep: category.default_sizes === false ? 2 : 3,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return this.setState({
                    step: category.default_sizes === false ? StepNames.DEFAULT_SIZES : StepNames.EXTRA_INGREDIENTS,
                    currentStep: category.default_sizes === false ? 2 : 4,
                    disabled: false
                }, this.validateStep.bind(this));

        }
    }


    render() {
        const { onSave } = this.props;
        const { currentStep, category, step, steps, disabled } = this.state;


        const mountPayload = this.onChangeCategory.bind(this);
        const prevStep = this.prevStep.bind(this);
        const nextStep = this.nextStep.bind(this);

        return (
            <>
                    <Steps steps={steps} currentStep={currentStep} />
                    <div className={styles.scrollContainer}>
                        {step === StepNames.NAME_AND_NUM_SIZES && (<SelectSizeStep category={category} mountPayload={mountPayload} />)}
                        {step === StepNames.DEFAULT_SIZES && (<SelectDrinkSizeStep category={category} mountPayload={mountPayload} />)}
                        {step === StepNames.SIZES && (<SetDrinkSizesStep category={category} onChange={mountPayload} />)}
                        {step === StepNames.EXTRA_INGREDIENTS && (<SetExtraIngredients category={category} mountPayload={mountPayload} />)}
                        {step === StepNames.AVAILABILITY && (<SetAvailabilityStep item={category} mountPayload={mountPayload} />)}
                    </div>
                <div className={styles.footer}>
                    <Button design="default-icon" onClick={prevStep}>
                        <Icon name="long-arrow-left" size="xl" />
                    </Button>

                    {step === StepNames.AVAILABILITY ? (
                        <Button design="primary-icon" onClick={() => !disabled && onSave && onSave(category)} disabled={disabled}>
                            <Icon name="check" size="xl" />
                        </Button>
                    ) : (
                        <Button design="primary-icon" onClick={nextStep} disabled={disabled}>
                            <Icon name="long-arrow-right" size="xl" />
                        </Button>
                    )}
                </div>
            </>
        );
    }
}